<div id="NewsPage">
  <h1>Admin Page</h1>
  <h2 class="secondary">NEWS</h2>
  <div class="content">
    <!-- Form per creare una nuova news -->
    <div class="box extra-padding">
      <div class="new-content">
        <div class="crea-nuova mb-4">
          <h2>Crea Nuova</h2>
        </div>
        <div class="titolo mb-2">
          <h3 class="lable">Titolo</h3>
          <input type="text" v-model="newsTitle">
        </div>
        <div class="testo mb-2">
          <h3 class="lable">Testo</h3>
          <textarea v-model="newsText" rows="3" style="width: 100%;"></textarea>
        </div>
        <div class="row flex-sm-row flex-column d-flex mb-4">
          <div class="data">
            <h3 class="lable">Data</h3>
            <input type="date" v-model="newsDate">
          </div>
          <div class="autore">
            <h3 class="lable">Autore</h3>
            <input type="text" v-model="newsAuthor">
          </div>
        </div>
        <div class="content-box d-flex justify-content-sm-between justify-content-center flex-wrap">
          <div class="drop-box mb-4 d-flex justify-content-center align-items-center" @dragover.prevent
            @drop="handleDrop" @click="openFileManager">
            Drop here
            <input type="file" ref="fileInput" style="display: none;" multiple @change="onFileChange">
          </div>
          <div v-for="(image, index) in imagePreviews" :key="index" class="image-preview mb-4"
            :style="{ backgroundImage: `url(${image.url})` }">
            <div class="x-button">
              <img src="../../../public/x.png" @click="removeImage(index)" class="x-button" alt="Remove Image" />
            </div>
          </div>
        </div>
        <div class="pubblica w-100 d-flex justify-content-center">
          <button @click="publishNews">PUBBLICA</button>
        </div>
      </div>
    </div>

    <!-- Visualizzazione delle news esistenti -->
    <div v-for="newsItem in newsList" :key="newsItem._id" class="box extra-padding">
      <div class="x-button">
        <img src="../../../public/x.png" @click="deleteNews(newsItem._id)" class="x-button" alt="Delete News" />
      </div>

      <div class="new-content mb-10">
        <h2 class="mb-3">{{ newsItem.titolo }}</h2>
        <h3 class="testo mb-2">{{ newsItem.testo }}</h3>
        <div class="row w-100 mb-3">
          <div class="from-data w-100">
            <h3>Da {{ newsItem.autore }} {{ formatDate(newsItem.dataNews) }}</h3>
          </div>
        </div>
        <div class="content-box justify-content-sm-between d-flex justify-content-center flex-wrap">
          <div v-for="(image, index) in newsItem.immagini" :key="index" class="image-preview mb-4"
            :style="{ backgroundImage: `url(${serverUrl}/news/immagine/${image.imgName})` }">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>